export const cardWidths = {
  provider: '20%',
  leaves: '12.5%',
  arrives: '12.5%',
  duration: '20%',
  destination: '25%',
  price: '15%',
}
